module.exports = __webpack_public_path__ + "static/img/case_1.a2e3a2e5.png";